import { AppRoute } from '@launchpad';
import React from 'react';
import { Switch } from 'react-router-dom';
import StipLogsList from './pages/stipLogs/StipLogsList';
import StipLogsDashboard from './pages/StipLogsDashboard';
import StipLogDetails from './pages/stipLogs/StiplogDetails';

export default class StipLogsNavigation extends React.PureComponent {
  render() {
    return (
      <Switch>
        <AppRoute path="/stip-logs/list" component={StipLogsList} />
        <AppRoute path="/stip-logs/details/:id" component={StipLogDetails} />
        <AppRoute path="/stip-logs" component={StipLogsDashboard} />
      </Switch>
    );
  }
}
